exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Study module should live here.\n * Import as neede like so:\n * ...\n * import studyStyles from 'studyModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"study-item\">\n * ...\n */\n\n.modules-study-___studyModuleStyles__study-item___1Ut93 {\n\n}\n\n.modules-study-___studyModuleStyles__-study-overview___Yei1R {\n  overflow: scroll;\n  max-height: 400px;\n}\n\n.modules-study-___studyModuleStyles__-viewing___pscyf {\n  width: 100%;\n  border-bottom: 1px solid #999;\n  padding: 5px 0;\n}\n", ""]);

// exports
exports.locals = {
	"study-item": "modules-study-___studyModuleStyles__study-item___1Ut93",
	"-study-overview": "modules-study-___studyModuleStyles__-study-overview___Yei1R",
	"-viewing": "modules-study-___studyModuleStyles__-viewing___pscyf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/study/studyModuleStyles.css
// module id = 1362
// module chunks = 1